var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2s545442ya)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#777E91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.367 12.502a.833.833 0 0 1 .876.788c.033.627.074 1.124.115 1.512.055.521.376.838.836.891.662.076 1.662.141 3.14.141 1.476 0 2.477-.065 3.138-.141.462-.053.781-.369.836-.89.096-.911.192-2.418.192-4.802 0-2.384-.096-3.891-.192-4.803-.055-.52-.374-.836-.836-.889-.661-.076-1.662-.141-3.139-.141-1.477 0-2.477.065-3.139.141-.46.053-.78.37-.836.89-.04.389-.082.886-.115 1.513a.833.833 0 1 1-1.664-.089c.034-.652.078-1.178.122-1.598.13-1.237 1.008-2.224 2.304-2.372.738-.084 1.805-.152 3.328-.152 1.524 0 2.59.068 3.329.152 1.295.148 2.173 1.133 2.304 2.37.104.985.2 2.552.2 4.978 0 2.426-.096 3.993-.2 4.978-.131 1.237-1.01 2.222-2.304 2.37-.739.084-1.805.152-3.329.152-1.523 0-2.59-.068-3.328-.152C8.709 17.2 7.83 16.214 7.7 14.977c-.044-.42-.087-.946-.122-1.598a.833.833 0 0 1 .788-.877z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.173 12.328a.833.833 0 1 1-1.179 1.179L1.077 10.59a.833.833 0 0 1 0-1.178l2.917-2.917a.833.833 0 0 1 1.179 1.179L3.679 9.168h7.988a.833.833 0 0 1 0 1.666H3.679l1.494 1.494z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2s545442ya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 10 10)",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxLogout);
export default __webpack_public_path__ + "static/media/bx-logout.a1f83b21e1750997a3c9ec8c96ef9071.svg";
export { ForwardRef as ReactComponent };